export default {
  template: '#vue-collection-subcategories',
  delimiters: ['${', '}'],
  props: [],
  computed: {},
  data() {
    return {
      n_categories: 0,
      scroll_pos: 0,
      scroll_max: 500,
      scroll_elem: null,
    }
  },
  methods: {
    scroll_handler(e) {
      this.scroll_pos = e.target.scrollLeft
      this.scroll_max = e.target.scrollWidth - e.target.clientWidth
    },
    resize_handler() {
      this.scroll_pos = this.scroll_elem.scrollLeft
      this.scroll_max = this.scroll_elem.scrollWidth - this.scroll_elem.clientWidth
    },
    scroll(direction) {
      this.scroll_elem.scrollBy({left: 390 * direction, behavior: 'smooth'})
    }
  },
  beforeUnmount() {
    if (this.scroll_elem) {
      window.removeEventListener('resize', this.resize_handler)
    }
  },
  mounted() {
    this.scroll_elem = document.getElementById('subcat-scroll')
    if (this.scroll_elem) {
      window.addEventListener('resize', this.resize_handler)
      this.$nextTick(() => {this.resize_handler()})
    }
  }
}